import React from "react";
import {observer} from "mobx-react-lite";
import nursingHomeStore from "@source/store/nursingHomeStore";
import {ConsentSteps} from "./consentSteps";
import {ConsentRequestState} from "@source/components/consentDocuments";
import ConsentDocumentsLayout from "../consentDocumentsLayout";

export const ConsentStepsPage = observer(() => {
  const nursingHomeId = nursingHomeStore.getId();
  const organizationId = nursingHomeStore.activeNursingHome?.organization?._id || "";
  if (!nursingHomeId || !organizationId) {
    return <ConsentDocumentsLayout><ConsentRequestState variant="empty" title="Select a nursing home" description="Choose a nursing home with an organization to view Consent Steps."/></ConsentDocumentsLayout>;
  }
  return <ConsentDocumentsLayout><ConsentSteps nursingHomeId={nursingHomeId} organizationId={organizationId}/></ConsentDocumentsLayout>;
});
